import envService from '@/services/env.service';
import { Button, ButtonProps, useBreakpointValue } from '@cmpsr/components';
import { useEffect, useState } from 'react';

type UserWayProps = {
  offsetConfig: Record<string, string>;
} & ButtonProps;

const userWayAccount = envService.getEnv().VITE_USERWAY_ACCOUNT;
const userWayScriptId = 'userWay-script-id';
const userWayStylesId = 'userWay-styles-id';

const setStyles = (bottomOffset: string, isWidgetVisible: boolean) => {
  const stylesElement = document.getElementById(userWayStylesId);
  if (stylesElement) document.head.removeChild(stylesElement);

  const css = `.userway_buttons_wrapper { margin-bottom: ${bottomOffset} !important; display: ${
    isWidgetVisible ? 'block' : 'none'
  } !important}`;
  const style = document.createElement('style');
  style.id = userWayStylesId;
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
};

const insertUserWayWidget = (bottomOffset: string, isWidgetVisible: boolean) => {
  const userWayScriptElement = document.getElementById(userWayScriptId);
  if (userWayScriptElement) return;

  const userWayScript = document.createElement('script');
  userWayScript.id = userWayScriptId;
  userWayScript.src = 'https://cdn.userWay.org/widget.js';
  userWayScript.setAttribute('data-account', userWayAccount);
  userWayScript.setAttribute('data-position', '5');
  userWayScript.setAttribute('data-size', 'small');
  document.head.appendChild(userWayScript);

  setStyles(bottomOffset, isWidgetVisible);
};

export default function UserWay({ offsetConfig, ...props }: UserWayProps) {
  const bottomOffset = useBreakpointValue(offsetConfig, { ssr: false }) ?? '35px';
  const [isWidgetVisible, setIsWidgetVisible] = useState(false);
  const [isWidgetInitialized, setIsWidgetInitialized] = useState(false);

  useEffect(() => {
    if (!isWidgetInitialized) insertUserWayWidget(bottomOffset, isWidgetVisible);
    setIsWidgetInitialized(true);
  }, [bottomOffset, isWidgetInitialized, isWidgetVisible]);

  const toggleWidget = () => {
    setIsWidgetVisible((isWidgetVisible) => {
      const newVisibility = !isWidgetVisible;
      setStyles(bottomOffset, newVisibility);
      return newVisibility;
    });
  };

  return (
    <Button onClick={toggleWidget} aria-label="Open accessibility widget" variant="link-accent" {...props}>
      Accessibility
    </Button>
  );
}
